import { DependencyList, Dispatch, SetStateAction, useState } from 'react'

import { isEqual, isFunction } from 'lodash'

interface UseStateEffect {
  <T>(stateable: T): [T, Dispatch<SetStateAction<T>>]
  <T>(stateable: () => T, deps: DependencyList): [T, Dispatch<SetStateAction<T>>]
}

const useStateEffect: UseStateEffect = <T>(stateable: T | (() => T), deps: DependencyList = []) => {
  const [value, setValue] = useState<T>(stateable)

  deps = isFunction(stateable) ? deps : [stateable]
  const [prevDeps, setPrevDeps] = useState(deps)

  if (!isEqual(prevDeps, deps)) {
    setValue(isFunction(stateable) ? stateable() : stateable)
    setPrevDeps(deps)
  }

  return [value, setValue] as [T, Dispatch<SetStateAction<T>>]
}

export default useStateEffect
